function Comp35() {
    var swiper = new Swiper(".comp-35 .swiper", {
        slidesPerView: "auto",
        spaceBetween: 48,
    });
}
Comp35();
